import axios from 'axios';

export const lineApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/lines`,
    headers: {
        'Content-Type': 'application/json'
    }
})